import { GlobalFormHandler } from './Forms';
import { InitDocumentViewer } from './Utils';
import './components/flash-messages';

new GlobalFormHandler();

InitDocumentViewer();
